import { render, staticRenderFns } from "./deposit-fait.vue?vue&type=template&id=65aeea5c&scoped=true&"
import script from "./deposit-fait.vue?vue&type=script&lang=js&"
export * from "./deposit-fait.vue?vue&type=script&lang=js&"
import style0 from "./deposit-fait.vue?vue&type=style&index=0&id=65aeea5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aeea5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
